import { Building } from "../Building";
import { RoofAddon } from "../../scene/addon/RoofAddon";
import { MaterialManager } from "../../material/MaterialManager";

// todo should this disappear if ridge vent is on?
export class RidgeRollTrim
{

	private _building : Building;

	private _trim : RoofAddon;

	constructor(building:Building)
	{
		this._building = building;
		this.init();
	}

	private init = () =>
	{
		var eaveTrimConfig = {
			"id": "",
			"label": "",
			"mesh": {
				"1": "#0200 - Ridge Roll - 1/12 Pitch",
				"2": "#0200 - Ridge Roll - 2/12 Pitch",
				"3": "#0200 - Ridge Roll - 3/12 Pitch",
				"4": "#0200 - Ridge Roll - 4/12 Pitch",
				"5": "#0200 - Ridge Roll - 4/12 Pitch"
			},
			"type": "roof",
			"size": {
				"length": 0
			},
			"material": MaterialManager.getInstance().trim_roofColor,
			"pitch": this._building.config.building.pitch
		};

		this._trim = new RoofAddon(eaveTrimConfig);

		this._trim.addToScene(this._building.scene3D);
		this._trim.show();

		this._building.config.building.propertyChange.add(this.update);
		this._building.config.building.pitch.signal.add(this.update);
		this._building.config.building.single_slope.signal.add(this.update);
		this.update();
	};

	private update = () =>
	{
		var metrics = this._building.config.metrics;

		var trimContainer = this._trim.container;
		trimContainer.position.z = (metrics.overhang_front - metrics.overhang_back) / 2;
		trimContainer.position.x = 0;
		trimContainer.position.y = metrics.top + 0.04;

		// 200 is the scale of the children meshes (set in blender)
		var length = metrics.length + metrics.overhang_front + metrics.overhang_back - 0.5;
		trimContainer.scale.z = length / 200;

		var single_slope = this._building.config.building.single_slope.value;
		if (single_slope && single_slope)
		{
			this._trim.hide();
		}
		else
		{
			this._trim.show();
		}
	}
}